import { useAppContext } from 'src/components/app-context';
import { Badge } from '@prisjakt/ui/badge';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Link as LinkComponent } from 'react-router-dom';
import styled from 'styled-components';
import { headerClickEvent } from '../../../../actions/product';

type Props = {
  category: { name: string; pathName: string };
  isExperiment: boolean;
  rank?: number | null;
};

export const RankBadge = (props: Props) => {
  const { category, isExperiment, rank } = props;

  const { t } = useAppContext();

  const dispatch = useDispatch();

  const handleRankCategoryClick = () =>
    dispatch(headerClickEvent('rank-category'));

  const renderBadge = (linkLocation?: string) => {
    if (!rank) return null;
    const badge = (
      <Badge
        color={isExperiment ? 'BLUE_INVERTED' : 'GREY'}
        key="categoryRank"
        text={t('product', 'rank.position', {
          rank: <span key="rank">{rank}</span>,
        })}
      />
    );
    if (!linkLocation) {
      return badge;
    }

    return <LinkComponent to={linkLocation}>{badge}</LinkComponent>;
  };

  return (
    <StyledRankBadge>
      <Link
        to={category.pathName}
        key="categoryLink"
        onClick={handleRankCategoryClick}
      >
        {renderBadge()}
      </Link>
    </StyledRankBadge>
  );
};

const StyledRankBadge = styled.div`
  color: ${p => p.theme.colors.base600};
`;

export const Link = styled(LinkComponent)`
  color: ${p => p.theme.colors.maybeBlue700};
  cursor: pointer;
  outline: none;

  &:hover,
  &:focus {
    color: ${p => p.theme.colors.maybeBlue500};
  }
`;
